import script from "./LoginPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginPage.vue?vue&type=script&lang=ts&setup=true"

import "./LoginPage.vue?vue&type=style&index=0&id=21700a00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21700a00"]])

export default __exports__